var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40682 7.62495C2.63632 4.60541 5.17298 2.66663 8.00016 2.66663C10.8273 2.66663 13.364 4.60541 14.5935 7.62495C14.6913 7.86506 14.6913 8.13486 14.5935 8.37496C13.364 11.3945 10.8273 13.3333 8.00016 13.3333C5.17298 13.3333 2.63632 11.3945 1.40682 8.37496C1.30905 8.13486 1.30905 7.86506 1.40682 7.62495ZM8.00016 12.0997C10.2795 12.0997 12.3693 10.5245 13.4334 7.99996C12.3693 5.47546 10.2795 3.90019 8.00016 3.90019C5.7208 3.90019 3.631 5.47546 2.56689 7.99996C3.631 10.5245 5.7208 12.0997 8.00016 12.0997ZM8.00016 10.4308C6.68098 10.4308 5.61157 9.34247 5.61157 7.99996C5.61157 6.65744 6.68098 5.56912 8.00016 5.56912C9.31935 5.56912 10.3888 6.65744 10.3888 7.99996C10.3888 9.34247 9.31935 10.4308 8.00016 10.4308ZM8.00016 9.19724C8.64991 9.19724 9.17663 8.6612 9.17663 7.99996C9.17663 7.33872 8.64991 6.80268 8.00016 6.80268C7.35042 6.80268 6.82369 7.33872 6.82369 7.99996C6.82369 8.6612 7.35042 9.19724 8.00016 9.19724Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/ShowPassword.6544ac9f9970bf2df5f44158d3c9192c.svg";
export { ForwardRef as ReactComponent };